import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['consortium-group'],
  queryOptions: {},
};

const getConsortiumGroupById = async (dpsID, cgId) => {
  const { data } = await axios.get(`/api/dps/${dpsID}/consortium_groups/${cgId}`);

  return data;
};

export const useConsortiumGroup = (dpsID, cgId, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, cgId], () => getConsortiumGroupById(dpsID, cgId), {
    initialData: { cg_name: 'Consortium Group', FA: {} },
    ...queryOptions,
  });
};
